import { ChangeDetectorRef, Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiService } from 'src/app/services/api.service';
import { UtilitiesService } from 'src/app/shared/utilities/utilities.service';

@Component({
  selector: 'app-task-management',
  templateUrl: './task-management.component.html',
  styleUrls: ['./task-management.component.css']
})
export class TaskManagementComponent implements OnInit {
  type: any;
  title = '';
  current_bp_business_id;
  bp_business_id;
  tm_task_id = '';
  history = []
  businessHistoryColoumn: string[] = ['Date', 'Time', 'Description', 'Business', 'Updated By'];
  page = {
    pageSizeOptions: [10, 25, 50, 100]
    , limit: 25
    , pageSize: 25
    , index: 0
  };
  constructor(
    private _api: ApiService,
    private spinner: NgxSpinnerService,
    @Optional() public dialogRef: MatDialogRef<any>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data
  ) {}

  ngOnInit() {
    this.type = this.data['type'];
    this.title = this.data['title'];
    this.current_bp_business_id = this.data['bizid'];

    if (this.type == 'view_history') {
      this.getTaskHistory(this.data, { page: 1 })
    }

  }

  getTaskHistory(data, page) {
    const apiData = {
      page: data.page,
      limit: this.page.pageSize,
      current_bp_business_id: data['bizid'],
      tm_task_id: data['value']['tm_task_id'],
      sortcolumn: "created",
      sortorder: "DESC"
    };
    this.spinner.show();
    this._api.functionPOST('task/getTaskUserEvents', apiData).subscribe((response) => {
      this.history = response['data']['rows'];
      this.spinner.hide();
    }, (error) => {
      console.log("POSt error : ", error)
    });
    this.spinner.hide();
  }

  historyPageChange($event) {
    this.page.pageSize = $event.pageSize;
    this.page.index = $event.pageIndex;
    this.getTaskHistory(this.data, { page: $event.pageIndex + 1 });
  }

}
